import styled, { css } from 'styled-components'

export const RemoveMediaContainer = styled.div<{ $showBackground: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  cursor: pointer;

  ${(props) =>
    props.$showBackground &&
    css`
      width: var(--spacer-6);
      height: var(--spacer-6);
      background-color: var(--white);
      display: flex;
      border-radius: var(--spacer-2);
      opacity: 0.7;
      color: #464b52;

      &:hover {
        opacity: 1;
      }
    `}
`

RemoveMediaContainer.displayName = 'RemoveMediaContainer'

export const CustomCloseUploadBoxButton = styled.button`
  &:focus {
    outline: none;
  }
`

CustomCloseUploadBoxButton.displayName = 'CustomCloseUploadBoxButton'
